import { confirm } from "devextreme/ui/dialog";
import { useContext } from "react";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitDesign } from "../../../cfi/retail-order/api/submit-design";
import { RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderFiles from "./RetailOrderFiles";

export default function CabinetDesignFiles() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const submitDesign = useSubmitDesign(
		order.details.retailOrderID,
		() => {
			showSuccessMessage("Design Packet has been submitted");
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			{
				order.details.files.length > 0 &&
				<RetailOrderFiles
					defaultFileType={order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign) ?
						FileTypes.CabinetDesignPacket : undefined}
					buttonCaption={order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign) ?
						'Upload Cabinet Design Packet' : undefined}
					replaceFile={true}
					onFileAdded={(fileType: FileTypes) => {
						if (fileType === FileTypes.CabinetDesignPacket &&
							order.details.activeARs.includes(AR.DealerToSubmitCabinetDesign)) {
							confirm("Do you want to submit the design?", "Submit Design")
								.then((result) => {
									if (result) {
										submitDesign.mutate();
									}
								});
						}
					}}
				/>
			}
		</>
	)
}
